import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { useState } from "react";
import "./styles/App.css";
import Home from "./screens/Home";
import Login, { TOKEN_KEY } from "./screens/Login";
import { LanguageProvider } from "./contexts/LanguageContext";
import ThemeProvider from "./contexts/ThemeContext";

const apiURL = "https://www.cloud.chatnotes.de";

export default function App() {
  const [token, setToken] = useState(() => {
    try {
      return localStorage.getItem(TOKEN_KEY) || null;
    } catch (e) {
      return null;
    }
  });

  const handleLoginSuccess = (newToken) => {
    setToken(newToken || localStorage.getItem(TOKEN_KEY));
  };

  const handleLogout = () => {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (e) {}
    setToken(null);
  };

  return (
    <div className="app">
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  token ? (
                    <Home
                      apiURL={apiURL}
                      token={token}
                      onLogout={handleLogout}
                    />
                  ) : (
                    <Login apiURL={apiURL} onSuccess={handleLoginSuccess} />
                  )
                }
              />
            </Routes>
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}
